import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Illustration } from '../components/image/Illustration';
import "./useGameLink.css";

const useGameLink = () => {
  const DEBUT = 1682892000 // 01/05/2023 00:00:00
  const FIN = 1688162399 //  30/06/2023 23:59:59

  const debut = new Date(DEBUT * 1000)
  const fin = new Date(FIN * 1000)
  const { t } = useTranslation()

  const isGameActive = () => {
    const dateActuelle = new Date()

    return debut <= dateActuelle && dateActuelle <= fin
  }

  const GetGameMsg = () => {

    return isGameActive() ? (
      <div className='game-msg-container'>
        <div>
          <Illustration className="game-logo" src={process.env.PUBLIC_URL + "/Game-gift.svg"} alt="Game gift" />
        </div>
        <Typography variant="subtitle1" className={"link-animation"}>
          {t('game.intro')}
        </Typography>
        <div>
          <Illustration className="game-logo" src={process.env.PUBLIC_URL + "/Game-gift.svg"} alt="Game gift" />
        </div>
      </div>
    ) : (
      ''
    )
  }

  const GetGameLink = () => {

    return isGameActive() ? (
      <section className='game-link'>
        <div>
          <Illustration className="game-logo" src={process.env.PUBLIC_URL + "/Game-logo.svg"} alt="Game logo" />
        </div>
        <div className="game-link-content">
          <Typography variant="subtitle1" className="game-link-title">
            {t('game.dialog-content')}
          </Typography>
          <Button className="link-button" startIcon={<Illustration className="game-arrow" src={process.env.PUBLIC_URL + "/Game-arrow.svg"} alt="Game arrow" />} variant="contained" color="secondary" fullWidth size="small" target="_blank" href="https://jeux.totalenergies.com/quiz/1196426_2767/.html">
            <Typography variant="subtitle1" className="button-sentence">
              {t('game.dialog-button')}
            </Typography>
          </Button>
        </div>
      </section>
    ) : (
      ''
    )
  }

  return {
    GetGameLink,
    GetGameMsg
  }
}

export default useGameLink
